export default {"src":"/_next/static/media/product.8d276f4e.svg","height":408,"width":610,"blurWidth":0,"blurHeight":0};